import React from "react";
import Building from './icons/building';
import Team from './icons/team';
import Tools from './icons/tools';
import Settings from './icons/settings';



const content = [
    {
        title: "Mid-sized businesses (20–1000 employees) with scaling operations",
        icon: <Building />
    },
    {
        title: "Teams with no formal PMO or inconsistent Project Management processes",
        icon: <Team />
    },
    {
        title: "Organizations adopting PM Software, but struggling with setup and adoption",
        icon: <Settings />
    },
    {
        title: "Departments managing cross-functional projects",
        icon: <Tools />
    }
];

const ForYou = () => {
    return (
        <div className="w-full lg:w-max flex flex-col justify-start items-start gap-6 px-4 md:px-12 py-24 lg:px-20 container mx-auto">
            <h2 className="text-4xl font-normal text-blue10">Is ReadyPMO Right For You?</h2>
            <div className="flex flex-col gap-4 justify-start items-start">
                <h3 className="text-base font-normal text-blue10 uppercase">Who it’s for</h3>
                {content.map((item, index) => (
                    <div key={index} className="gap-4 flex flex-row justify-start items-start text-left">
                        <div className="w-10 h-10 aspect-square flex justify-center items-center bg-blue10 p-2 rounded-full">
                        {item.icon}
                        </div>
                        <p className="text-xl font-bold text-blue10">{item.title}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ForYou;